import { showSuccess } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useCancelRequestMutation, useFetchEligibilityQuery, useLazyFetchEligibilityQuery } from './api';
import { closeSeatRequestModal } from './slice';
import { ModalTitle } from './styles';
const customModalTitleCss = "c151i0al";
const CustomModalTitle = forwardRef((props, ref) => <ModalTitle ref={ref} {...props} className={classNames(customModalTitleCss, props.className)} />);
const subtitleCss = "s1663thb";
const Subtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h3';
  return <Component ref={ref} {...restProps} className={classNames(subtitleCss, props.className)} />;
});
const descriptionCss = "dgil7bu";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
export const ExistingRequestStep = () => {
  const dispatch = useDispatch();
  const {
    isLoading,
    data,
    isError
  } = useFetchEligibilityQuery();
  const [submitCancel, {
    isError: isCancelError,
    isLoading: isCancelLoading,
    isSuccess: isCancelSuccess
  }] = useCancelRequestMutation();
  const [refetchEligibility] = useLazyFetchEligibilityQuery();
  useEffect(() => {
    if (isCancelSuccess) {
      dispatch(closeSeatRequestModal());
      dispatch(showSuccess(I18n.t('publisher.growth_experiments.seat_requests.cancel_modal.success_toast')));
      refetchEligibility();
    }
  }, [dispatch, isCancelError, isCancelSuccess, refetchEligibility]);
  if (isLoading || isError) return <Loader />; // user will see server error toast, just show loading if errors out... shouldn't happen

  return <div>
      <CustomModalTitle>
        {I18n.t('publisher.growth_experiments.seat_requests.cancel_modal.title')}
      </CustomModalTitle>

      <Subtitle>
        {I18n.t('publisher.growth_experiments.seat_requests.cancel_modal.subtitle', {
        email: data?.existingRequest?.ownerEmail
      })}
      </Subtitle>

      <Description>
        <BodyText>
          {I18n.t('publisher.growth_experiments.seat_requests.cancel_modal.description')}
        </BodyText>
      </Description>

      <Button decoration="secondary-outline" loading={isCancelLoading} onClick={() => submitCancel(data?.existingRequest?.uuid)} wide>
        {I18n.t('publisher.growth_experiments.seat_requests.cancel_modal.cta')}
      </Button>
    </div>;
};

require("./existing_request_step.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./existing_request_step.js");